export default __webpack_public_path__ + "static/Moniqa-MediumHeading-8f65e3d0ff2e952157533fdfb59e9ef3.woff2";